interface Exchange {
  id: number;
  selectedMetrics: string[]; // or whatever type your metrics are
  defaultMetrics: string[];
  [key: string]: any; // for additional properties
}

export const rawDimensions = [
    "Account_Name",
    "account_name",
    "ad_account_name",
    "advertiser",
    "advertiser_name",
    "advertiserCurrencyCode",
    "advertiser_country",
    "advertiser_time_zone",
    "Campaign_Name",
    "campaign_name",
    "campaign",
    "title_part_1",
    "title_part_2",
    "title_part_3",
    "campaign_status",
    "campaign_status_active",
    "current_status",
    "campaign_objective",
    "campaign_objective_type",
    "Adset_Name",
    "ad_group_name",
    "Ad_Group_Name",
    "Ad_Name",
    "ad_name",
    "ad_title",
    "ad_status",
    "current_status",
    "creative_name",
    "adName",
    "advertisement",
    "creative_type",
    "creative_mediaType",
    "vertical_ad_type",
    "creative_size",
    "ad_size",
    "line_item",
    "tactic",
    "order_name",
    "order_line_name",
    "insertion_order",
    "date",
    "Date_Start",
    "Date_Stop",
    "Impression_Date",
    "flight_name",
    "deviceType",
    "site_type",
    "site_name",
    "region_code",
    "country_code",
    "city",
    "dma_name",
    "uniques",
    "uniqueHouseholds",
    "uniquePersons",
    "adEnvironment",
    "lineitem_name",
    "amount_type", "rate",
    "date","Date_Start","Impression_Date","day","hour_of_day","reportHour",
    "deviceType","Device platform","DEVICE","device_type",
    "adFormat","Ad creative object type","AD_GROUP_TYPE","ad_type",
    "line_item_start_date","line_item_end_date",
    ];

export const formatMetricName = (metric: string): string => {
  const knownAcronyms = ['cpc', 'cpm', 'ctr', 'cpa','cvr'];
  const specialMetrics = ['Actual_Billable__c','Clicks__c','Conversions__c'];
  
  const metricsNameArr: { [key: string]: string[] } = {
    "Player 100% Complete": ["Completed_Views__c"],
    "Player 25% Complete": ["video_watched_25_percent"],
    "Player 50% Complete": ["video_watched_50_percent"],
    "Player 75% Complete": ["video_watched_75_percent"],
    "Conversion Value": ["conversion_value"],
    "All Conversions": ["all_conversions"],
    "All Conversion Value": ["all_conversion_value"],
    "View Through Conversions": ["view_through_conversions"],
    "Duration": ["creativeDurationInSeconds"],
    "Device": ["deviceType", "Device platform", "DEVICE", "device_type"],
    "Rate Type": ["amount_type"],
    "Ad Format":["Ad_Size__c"],
    "Creative":["creative_name"],
    "Order Name":["campaign_name","Campaign_Name","campaign"],
    "Line Item Start Date":["Start_Date__c"],
    "Line Item End Date":["End_Date__c"],
    "Impressions":["Served__c"],
    "Client Media Spend":["Cost__c"],
    "Video Played to 100%":["video_quartile_p100_rate"],
  };

  // Check if metric is in specialMetrics and remove __c from the end
  let processedMetric = metric;
  if (specialMetrics.includes(metric)) {
    processedMetric = metric.replace(/__c$/, '');
  }

  // Check if the processed metric exists in any of the metricsNameArr values arrays
  const normalizedKey = Object.keys(metricsNameArr).find(
    key => metricsNameArr[key].some(
      value => value.toLowerCase() === processedMetric.toLowerCase()
    )
  );

  if (normalizedKey) {
    return normalizedKey;
  }

  return processedMetric
    .replace(/_/g, ' ')                             // Replace underscores with spaces
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')         // Insert space before capital letter following lowercase/number
    .split(' ')                                     // Split into words
    .map(word => {
      const lower = word.toLowerCase();
      return knownAcronyms.includes(lower)
        ? lower.toUpperCase()                       // Uppercase known acronyms
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); // Title Case
    })
    .join(' ');
};

export const formatMetricString = (str:string)=>{
  
  return str.replace(/[_\s-]+/g, "").toLowerCase();
}




export const applySelectAllMetrics = <T extends {
  id: number;
  selectedMetrics: any[];
  display_metrics: any[];
}>(
  checked: boolean,
  selectedExchangeId: number | null,
  setExchangeSelectionState: React.Dispatch<React.SetStateAction<T[]>>,
  setAllMetrics: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setAllMetrics(checked);

  if (selectedExchangeId === null) return;

  setExchangeSelectionState(prev =>
    prev.map(exchange => {
      return exchange.id === selectedExchangeId
        ? { ...exchange, selectedMetrics: checked ? [...exchange.display_metrics] : [] }
        : exchange;
    })
  );


};

export const toggleMetricSelection = <T extends {
  id: number;
  selectedMetrics: string[];
}>(
  exchangeId: number,
  metric: string,
  setExchangeSelectionState: React.Dispatch<React.SetStateAction<T[]>>
) => {

  setExchangeSelectionState(prev =>
    prev.map(exchange =>
      exchange.id === exchangeId
        ? {
          ...exchange,
          selectedMetrics: exchange.selectedMetrics.some(m => formatMetricString(m) === formatMetricString(metric))
            ? exchange.selectedMetrics.filter(m => formatMetricString(m) !== formatMetricString(metric))
            : [...exchange.selectedMetrics, metric]
        }
        : exchange
    )
  );
};

// more grouping can be added
export const autoSelectRules: Record<string, string[]> = {
  ctr: ["clicksc"],
  completedviewsc: ["completionrate"],
};

// Disables certain metrics when one is picked
export const disabledRules: Record<string, string[]> = {
  estimatedspend:["cpa","cpc"],
  conversionsc:["cvr"],
};


export const isMetricDisabled = (
  metric: string,
  selectedMetrics: string[]
): boolean => {
  
  const camelMetric = formatMetricString(metric);
  
  // We invert the logic so the dependents (cpc, cpa) stay disabled
  // until estimatedSpend is actually chosen.
  return Object.entries(disabledRules).some(([key, dependents]) => {
    const parent = formatMetricString(key);
    return (
      dependents.map(formatMetricString).includes(camelMetric) &&
      !selectedMetrics.map(formatMetricString).includes(parent)
    );
  });
};



export const toggleMetricwithDependencies = <T extends { id: number; selectedMetrics: string[]; display_metrics?: string[] }>(
  exchangeId: number,
  metric: string,
  setExchangeSelectionState: React.Dispatch<React.SetStateAction<T[]>>
) => {

  setExchangeSelectionState(prev =>
    prev.map(exchange => {
      if (exchange.id !== exchangeId) return exchange;

      // Create a map for normalized comparison while preserving original format
      const selectedNormalizedMap = new Map<string, string>();
      exchange.selectedMetrics.forEach(m => {
        selectedNormalizedMap.set(formatMetricString(m), m);
      });

      // Create a map of available metrics for finding original format
      const availableMetricsMap = new Map<string, string>();
      (exchange.display_metrics || []).forEach(m => {
        availableMetricsMap.set(formatMetricString(m), m);
      });

      const normalizedMetric = formatMetricString(metric);

      // Helper function to find original format or use provided format
      const getOriginalFormat = (metricName: string): string => {
        const normalized = formatMetricString(metricName);
        return availableMetricsMap.get(normalized) || metricName;
      };

      // Special handling for estimatedSpend
      if (normalizedMetric === "estimatedspend") {
        if (selectedNormalizedMap.has(normalizedMetric)) {
          // Unchecking estimatedSpend → remove estimatedSpend, cpa, cpc
          selectedNormalizedMap.delete("estimatedspend");
          selectedNormalizedMap.delete("cpa");
          selectedNormalizedMap.delete("cpc");
        } else {
          // Checking estimatedSpend → only add estimatedSpend (preserve original format)
          selectedNormalizedMap.set("estimatedspend", getOriginalFormat(metric));
        }

        // Return with original format preserved
        return { ...exchange, selectedMetrics: Array.from(selectedNormalizedMap.values()) };
      }

      // Special handling for conversions
      if (normalizedMetric === "conversionsc") {
        if (selectedNormalizedMap.has(normalizedMetric)) {
          // Unchecking conversions → remove conversions, cvr
          selectedNormalizedMap.delete("conversionsc");
          selectedNormalizedMap.delete("cvr");
        } else {
          // Checking conversions → only add conversions (preserve original format)
          selectedNormalizedMap.set(normalizedMetric, getOriginalFormat(metric));
        }

        // Return with original format preserved
        return { ...exchange, selectedMetrics: Array.from(selectedNormalizedMap.values()) };
      }

      // Recursive logic for other metrics
      const addMetricRecursive = (m: string) => {
        const normalized = formatMetricString(m);
        if (selectedNormalizedMap.has(normalized)) return;

        // Add with original format preserved
        selectedNormalizedMap.set(normalized, getOriginalFormat(m));

        // Forward dependencies
        (autoSelectRules[normalized] || []).forEach(addMetricRecursive);

        // Reverse dependencies
        Object.entries(autoSelectRules).forEach(([parent, children]) => {
          if (children.map(c => formatMetricString(c)).includes(normalized)) {
            addMetricRecursive(parent);
          }
        });
      };

      const removeMetricRecursive = (m: string) => {
        const normalized = formatMetricString(m);
        if (!selectedNormalizedMap.has(normalized)) return;
        selectedNormalizedMap.delete(normalized);

        // Forward dependencies
        (autoSelectRules[normalized] || []).forEach(removeMetricRecursive);

        // Reverse dependencies
        Object.entries(autoSelectRules).forEach(([parent, children]) => {
          if (children.map(c => formatMetricString(c)).includes(normalized)) {
            removeMetricRecursive(parent);
          }
        });
      };

      if (selectedNormalizedMap.has(normalizedMetric)) {
        removeMetricRecursive(metric);
      } else {
        addMetricRecursive(metric);
      }

      return { ...exchange, selectedMetrics: Array.from(selectedNormalizedMap.values()) };
    })
  );
};




export const clearAllMetrics = <T extends {
  id: number;
  selectedMetrics: string[];
}>(
  selectedExchangeId: number | null,
  setExchangeSelectionState: React.Dispatch<React.SetStateAction<T[]>>,
  setAllMetrics: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (selectedExchangeId === null) return;

  setAllMetrics(false);
  setExchangeSelectionState(prev =>
    prev.map(exchange =>
      exchange.id === selectedExchangeId
        ? { ...exchange, selectedMetrics: [] }
        : exchange
    )
  );
};



export const sortByExchangeOrder = <T extends { id: number }>(items: T[], order: number[]): T[] => {
  if (order.length === 0) return items;
  return [...items].sort((a, b) => {
    const indexA = order.indexOf(a.id);
    const indexB = order.indexOf(b.id);
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });
};

export const formatUSD = (value: number | null | undefined): string => {
  if (value == null) return "-"; // fallback if null/undefined
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};


